import { WsError } from './WsError';

export enum NetworkErrorCode {
  Unauthorized = 401,
  ServiceUnavailable = 503,
  InternalError = 501,
}

export class WsNetworkError extends WsError {
  constructor(public code: NetworkErrorCode, public message: string) {
    super(code, message);
  }
}
